// extracted by mini-css-extract-plugin
export var active = "_kc-2";
export var recordingDot = "_kc-1";
export var recordingIndicator = "_kc-0";